import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useRemoveRoom = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: async (data: { roomId: string }) =>
      await httpService.panel.panelRoomsDestroy(data.roomId),
    onSuccess,
    onError
  })

export default useRemoveRoom
